export const SHIPPING_CLASSES_REDUCER_NAME = 'shipping-classes';

export const shippingClassesReducer = (state = {}) => state;

export const getShippingClasses = (state) => state[SHIPPING_CLASSES_REDUCER_NAME];
